import { Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

export function AvatarContextMenuJSX({ position, open, onClose, onChange=(url)=>{}, onDelete=()=>{} }) {
    const { t } = useTranslation();

    return <Menu
        open={open}
        onClose={onClose}
        anchorReference="anchorPosition"
        anchorPosition={open ? {
            top: position.getY(),
            left: position.getX()
        } : undefined}
    >
        <MenuItem onClick={()=>{
            document.getElementById('input-avatar-context-menu').click();
        }}>{t('actions.change')}</MenuItem>
        <MenuItem onClick={onDelete}>{t('actions.deleteNormal')}</MenuItem>
        <input 
                id={`input-avatar-context-menu`}
                type="file"
                style={{display:'none'}}
                accept="image/webp"
                onChange={(e) => {
                    onChange(URL.createObjectURL(e.target.files[0]));
                }}
            />
    </Menu>
}